import { useEffect } from "react";
import { TFormHookParams, IFormSection } from "../../types/common";
import useGet from "../common/useGet";
import { API_ACCOUNTS_ROLES, API_WAGES_CONFIGURATIONS } from "../../utils/apis";
import { addSelectItem, getRegister } from "../../utils/helpers";
import { URL_WAGES_CONFIGURATIONS } from "../../utils/urls";

export const useWagesConfigurationsForm = ({
  id,
  form,
}: TFormHookParams = {}) => {
  const isUpdate = !!id;

  const { loadData: getRoles, data: roles, loading: loadingRoles } = useGet();

  useEffect(() => {
    getRoles({ api: API_ACCOUNTS_ROLES });
  }, []);

  const sections: IFormSection[] = [
    {
      title: "Wage Details",
      fields: [
        {
          field_name: "staff_type",
          type: "select",
          label: "Roles",
          props: {
            required: isUpdate ? false : true,
            disabled: isUpdate,
            placeholder: "Select Role",
          },
          options_data: roles?.results?.map((sup: any) =>
            addSelectItem({
              label: sup?.name,
              value: sup?.name?.toUpperCase(),
            }),
          ),
          loading: loadingRoles,
        },
        {
          field_name: "commission_percentage",
          type: "number",
          label: "Commission (%)",
          props: {
            required: isUpdate ? false : true,
            min: 0,
          },
        },
        {
          field_name: "bonus_threshold",
          type: "number",
          label: "Bonus Threshold",
          props: {
            required: isUpdate ? false : true,
            min: 0,
          },
        },
        {
          field_name: "fixed_wage",
          type: "number",
          label: "Fixed Wage",
          visible: form?.staff_type !== "AGENT",
          props: {
            required: isUpdate ? false : true,
            min: 0,
          },
        },
        {
          field_name: "working_days",
          type: "number",
          label: "Working Days",
          props: {
            required: isUpdate ? false : true,
            min: 0,
          },
        },
        {
          field_name: "is_active",
          label: "Status",
          type: "select",
          visible: isUpdate,
          props: {
            required: isUpdate ? false : true,
            placeholder: "Select Status",
            options: [
              { value: true, label: "Active" },
              { value: false, label: "Inactive" },
            ],
          },
        },
      ],
    },
  ];

  const title = "Wages Configuration";
  const redirect = getRegister(URL_WAGES_CONFIGURATIONS);

  const onSubmit = (payload: any) => {
    if (id) {
      return {
        id,
        api: API_WAGES_CONFIGURATIONS,
        params: {
          ...payload,
        },
      };
    }
    return {
      api: API_WAGES_CONFIGURATIONS,
      params: {
        ...payload,
      },
    };
  };

  return {
    sections,
    onSubmit,
    title,
    redirect,
  };
};
